import React, { useEffect, useState } from "react";
import ContentHeading from "../../../../components/layout/content/ContentHeading";
import InputTextField from "../../../../components/input/inputTextField";
import TableCustom from "../../../../components/table/tableCustom";
import TableRowCommon from "../../../../components/table/TableRowCommon";
import { useDispatch } from "react-redux";
import {
  NavigateFunction,
  useLocation,
  useNavigate,
  useParams,
} from "react-router-dom";
import { RemoveRedEyeOutlined, SearchOutlined } from "@mui/icons-material";
import { debouncedApiCall } from "../../../../utils/app.utils";
import { CourseAnnualDetailAPI } from "../../../../api/course-annual-detail/course-annual-detail.api";
import FilterSelect from "../../../../components/select/filterSelect";
import { MenuItem, Typography } from "@mui/material";
import { routeName } from "../../../../routes/routeName";
import { facultyApi } from "../../../../api/factulty/factulty.api";
import { degreeApi } from "../../../../api/degree/degree.api";
import { dateToView, timeToView } from "../../../../utils/date.utils";
import { icons } from "../../../../assets/icons/icons";
import {
  alertActive,
  alertError,
  alertSuccess,
  swalSuccess,
} from "../../../../components/alert/swal";
import {
  setLoading,
  unsetLoading,
} from "../../../../store/loading/loading.slice";
import NavigateListCustom from "../../../../components/navigation/NavigationListCustom";
import {
  ButtonBack,
  ButtonOutlined,
  ButtonPrimary,
} from "../../../../components/button/ButtonCustoms";
import ModalCustom from "../../../../components/modal/ModalCustom";
import moment from "moment";
import InputDatePicker from "../../../../components/input/inputDatePicker";
import UploadFile from "../../../../components/upload/UploadFile";
import LinkCard from "../../../../components/LinkCard/LinkCard";
import { getFileExtension } from "../../../../utils/fileTypeDownload";
import { saveAs } from "file-saver";
import { CourseAnnualApi } from "../../../../api/course-annual/course-annual.api";
import { useTranslation } from "react-i18next";

type Props = {};

const SubjectTaughtCourseDetail: React.FC<Props> = (props: Props) => {
  const { t } = useTranslation();
  const navigate: NavigateFunction = useNavigate();
  const dispatch = useDispatch();
  const { id } = useParams();

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const prop_courses_no = queryParams.get("courses_no");
  const prop_courses_name = queryParams.get("courses_name");
  const prop_id_course_of_study = queryParams.get("id_course_of_study");
  const prop_year = queryParams.get("year");
  const prop_term = queryParams.get("term");

  const [data, setData] = useState<any[]>([]);

  const [inputValue, setInputValue] = useState<any>({
    id: "",
    publish_date: "",
    publish_time: "",
    name: "",
    detail: "",
    link: "",
  });
  const [files, setFiles] = useState<File[]>([]);
  const [filesApi, setFilesApi] = useState<File[]>([]);

  const [form, setForm] = useState<any>({
    estimate_start_date: '',
    estimate_end_date: ''
  })
  const [isModalForm, setisModalForm] = useState<boolean>(false);
  const [mode, setMode] = useState<string>("ADD");

  const [search, setSearch] = useState<string>("");
  const [open, setOpen] = useState<boolean>(false);

  const [page, setPage] = useState<number>(1);
  const [pageLimit, setPageLimit] = useState<number>(10);
  const [totalItems, setTotalItems] = useState<number>(0);
  const [sortBy, setSortBy] = useState<string>("");
  const [sortType, setSortType] = useState<string>("ASC");
  const handleRequestSort = (sortBy: string, sortType: string) => {
    setSortBy(sortBy);
    setSortType(sortType);
  };

  const handleCloseModal = () => {
    setisModalForm(false);
    setInputValue({
      publish_date: "",
      publish_time: "",
      name: "",
      detail: "",
      link: "",
    });
    setFiles([]);
  };

  const getData = async (id: number) => {
    let query: any = {
      page: page,
      limit: pageLimit,
      sortBy: sortBy,
      sortType: sortType,
      keyword: search ?? "",
    };

    const res =
      await CourseAnnualDetailAPI.getCourseAnnualDetailListByIdCourseAnnual(
        +id,
        query
      );
    const data = res.data;
    if (data.status < 300) {
      setData(res.data?.data?.items ?? []);
      setTotalItems(res.data?.data?.meta?.totalItems || 0);
    } else {
      setData([]);
    }
  };

  const handleDelete = async (id_detail: number) => {
    if (id && id_detail) {
      alertActive(
        t("ลบสื่อประกอบการเรียนการสอน"),
        t("ท่านต้องการลบสื่อประกอบการเรียนการสอน ใช่หรือไม่"),
        undefined,
        undefined,
        async () => {
          dispatch(setLoading());
          await CourseAnnualDetailAPI.deleteCourseAnnualDetailById(+id_detail)
            .then((res) => {
              if (res.status < 300) {
                alertSuccess(
                  t("ลบสื่อประกอบการเรียนการสอน เรียบร้อย"),
                  undefined,
                  undefined,
                  () => {
                    getData(+id);
                  }
                );
              }
            })
            .catch(() => {
              alertError(t("ลบสื่อประกอบการเรียนการสอน ไม่สำเร็จ"));
            })
            .finally(() => {
              dispatch(unsetLoading());
            });
        }
      );
    }
    return;
  };

  const headCells = [
    {
      id: "period",
      width: 150,
      sortable: false,
      disablePadding: false,
      align: "start",
      label: t("ชื่อ"),
    },
    {
      id: "period",
      width: 75,
      sortable: false,
      disablePadding: false,
      align: "start",
      label: t("วันที่เผยแพร่"),
    },
    {
      id: "period",
      width: 75,
      sortable: false,
      disablePadding: false,
      align: "start",
      label: t("เวลาที่เผยแพร่"),
    },
    {
      id: "period",
      width: 75,
      sortable: false,
      disablePadding: false,
      align: "start",
      label: t("ผู้ที่สร้าง/แก้ไข"),
    },
    {
      id: "period",
      width: 75,
      sortable: false,
      disablePadding: false,
      align: "start",
      label: t("วันที่สร้าง/แก้ไข"),
    },
    {
      id: "action",
      width: 50,
      sortable: false,
      disablePadding: false,
      align: "start",
      label: "",
    },
  ];

  const renderData = (objData: any, no: any) => {
    no = page * pageLimit - pageLimit + no + 1;
    const {
      cad_id_course_annual_detail,
      cad_course_annual_date,
      cad_course_annual_time,
      cad_course_annual_detail_name,
      create_name,
      created_date,
      modified_name,
      modified_date,
    } = objData;

    const objRenderData = {
      key: cad_id_course_annual_detail,
      id: no,
      obj: objData,
      columns: [
        {
          option: "TEXT",
          align: "start",
          label: cad_course_annual_detail_name ?? "-",
        },
        {
          option: "TEXT",
          align: "start",
          label: cad_course_annual_date
            ? dateToView(cad_course_annual_date)
            : "",
        },
        {
          option: "TEXT",
          align: "start",
          label: cad_course_annual_time ?? "",
        },
        {
          option: "TEXT",
          align: "start",
          label: create_name ?? "-",
        },
        {
          option: "TEXT",
          align: "start",
          label: created_date ? dateToView(created_date) : "",
        },
        {
          option: "TEXT",
          align: "center",
          label: (
            <div
              style={{
                display: "flex",
                textAlign: "center",
                justifyContent: "center",
              }}
            >
              <img
                onClick={() => {
                  setMode("VIEW");
                  setisModalForm(true);
                  getDataDetail(cad_id_course_annual_detail);
                }}
                src={icons.eye}
                alt="eye"
                style={{ cursor: "pointer" }}
              />
              <img
                onClick={() => {
                  setMode("UPDATE");
                  setisModalForm(true);
                  getDataDetail(cad_id_course_annual_detail);
                }}
                src={icons.edit}
                alt="edit"
                style={{ cursor: "pointer", margin: "0px 12px" }}
              />
              <img
                src={icons.bag_cross}
                alt="bag_cross"
                style={{ cursor: "pointer" }}
                onClick={() => {
                  setMode("DELETE");
                  handleDelete(cad_id_course_annual_detail);
                }}
              />
            </div>
          ),
        },
      ],
    };
    return <TableRowCommon {...objRenderData} />;
  };

  useEffect(() => {
    if (id) {
      getData(+id);
    }
  }, [page, pageLimit, sortBy, sortType, search, id]);

  const handlePasteLink = async () => {
    try {
      const text = await navigator.clipboard.readText(); // Get clipboard content
      setInputValue({
        ...inputValue,
        link: text,
      });
    } catch (err) { }
  };

  const handleDeleteLink = async () => {
    try {
      setInputValue({
        ...inputValue,
        link: "",
      });
    } catch (err) { }
  };

  const handleClose = async () => {
    const body = {
      ...form
    }
    dispatch(setLoading());
    await CourseAnnualApi.closeClass(id, body)
      .then((res) => {
        if (res.status < 300) {
          swalSuccess(t('ปิดคราสเรียนเรียบร้อย'), undefined, undefined, () => {
            setOpen(false)
            setForm({})
            navigate(`/subject-taught/${prop_id_course_of_study}/course-annual?year=${prop_year}&term=${prop_term}`)
          })

        }
      })
      .catch((error) => console.log(error))
      .finally(() => dispatch(unsetLoading()));

  }
  const handleSubmit = async () => {
    const title =
      mode === "ADD"
        ? t("เพิ่มสื่อประกอบการเรียนการสอน")
        : mode === "VIEW"
          ? t("สื่อประกอบการเรียนการสอน")
          : t("แก้ไขสื่อประกอบการเรียนการสอน");

    if (!id || files.length === 0) {
      return alertError(title, t("{{title}} ไม่สำเร็จ", { title }));
    }

    dispatch(setLoading());

    const formData = new FormData();
    formData.append("course_annual_date", inputValue.publish_date);
    formData.append("course_annual_time", inputValue.publish_time);
    formData.append("course_annual_detail_name", inputValue.name);
    formData.append("course_annual_detail_desc", inputValue.detail);
    formData.append("course_annual_detail_link", inputValue.link);

    // files.forEach((file) => {
    //   formData.append("files", file);
    // });

    // // Prepare the files for upload
    const uploadFiles = files.filter((file: any) => !file?.is_api);

    uploadFiles.forEach((file: any) => {
      formData.append("files", file);
    });

    try {
      let response;

      if (inputValue.id) {
        response = await CourseAnnualDetailAPI.updateCourseAnnualDetailById(
          inputValue.id,
          formData
        );
      } else {
        response =
          await CourseAnnualDetailAPI.createCourseAnnualDetailByIdCourseAnnual(
            +id,
            formData
          );
      }

      if (response.status < 300) {
        alertSuccess(title, t("{{title}} สำเร็จ", { title }), undefined, () => {
          getData(+id);
          handleCloseModal();
        });
      }
    } catch (err: any) {
      alertError(title, err?.response?.data?.message || t("{{title}} ไม่สำเร็จ", { title }));
    } finally {
      dispatch(unsetLoading());
    }
  };

  const handleChange = (name: string, value: string) => {
    setInputValue((prev: any) => ({ ...prev, [name]: value }));
  };

  // Handle file upload
  const handleDrop = (newFiles: File[]) => {
    setFiles((prevFiles) => [...prevFiles, ...newFiles]); // Append new files
  };

  // Handle file delete
  const handleDeleteFile = (index: number) => {
    setFiles((prevFiles) => prevFiles.filter((_, i) => i !== index));
  };

  const getDataDetail = async (id_course_annual_detail: number) => {
    try {
      const res = await CourseAnnualDetailAPI.getCourseAnnualDetailById(
        +id_course_annual_detail
      );
      const data = res.data;

      if (data.status < 300) {
        const filesData =
          data.data?.files?.map((file: any) => ({
            id: file.id_course_annual_file,
            name: file.course_annual_file_name,
            type: file.course_annual_file_type,
            path: file.course_annual_file_path,
            size: file.course_annual_file_size,
            is_api: true,
          })) ?? [];

        setInputValue({
          id: data.data?.central_budget_detail?.id_course_annual_detail,
          publish_date: data.data?.central_budget_detail?.course_annual_date
            ? moment(
              data.data?.central_budget_detail?.course_annual_date
            ).format("YYYY-MM-DD")
            : data.data?.central_budget_detail?.course_annual_date,
          publish_time: data.data?.central_budget_detail?.course_annual_time,
          name: data.data?.central_budget_detail?.course_annual_detail_name,
          detail: data.data?.central_budget_detail?.course_annual_detail_desc,
          link: data.data?.central_budget_detail?.course_annual_detail_link,
        });

        setFiles(filesData);
        setFilesApi(filesData);
      } else {
        setInputValue({
          id: "",
          publish_date: "",
          publish_time: "",
          name: "",
          detail: "",
          link: "",
        });
        setFiles([]);
      }
    } catch (error) {
      console.error("Error fetching details:", error);
    }
  };

  const handleDownloadFile = async (id_file: number, type: string) => {
    dispatch(setLoading());
    await CourseAnnualDetailAPI.getCourseAnnualDetailFile(id_file)
      .then((res) => {
        if (res.status < 300) {
          const response = res.data;

          const blob = new Blob([response]);

          const fileName = `${new Date().getTime()}.${type}`;

          saveAs(blob, fileName);
        }
      })
      .catch((error) => console.log(error))
      .finally(() => dispatch(unsetLoading()));
  };

  return (
    <div>
      <ModalCustom
        open={isModalForm}
        title={
          mode === "ADD"
            ? t("เพิ่มสื่อประกอบการเรียนการสอน")
            : mode === "VIEW"
              ? t("สื่อประกอบการเรียนการสอน")
              : t("แก้ไขสื่อประกอบการเรียนการสอน")
        }
        subTitle={""}
        onClose={handleCloseModal}
        component={
          <div className="w-full">
            <section className="grid grid-cols-12 gap-x-6 gap-y-6">
              {/* Date Picker */}
              <article className="col-span-12 sm:col-span-6 md:col-span-6 lg:col-span-6 space-y-2">
                <InputDatePicker
                  value={inputValue.publish_date}
                  heading={t("วันที่เผยแพร่")}
                  required
                  placeholder={t("ระบุวันที่เผยแพร่")}
                  onChange={(e: any) =>
                    handleChange("publish_date", moment(e).format("YYYY-MM-DD"))
                  }
                  allowClear
                  disabled={mode === "VIEW"}
                />
              </article>

              {/* Time Picker */}
              <article className="col-span-12 sm:col-span-6 md:col-span-6 lg:col-span-6 space-y-2">
                <InputTextField
                  value={inputValue.publish_time}
                  type="time"
                  heading={t("เวลาที่เผยแพร่")}
                  required
                  placeholder={t("ระบุเวลาที่เผยแพร่")}
                  onchange={(e: React.ChangeEvent<HTMLInputElement>) =>
                    handleChange("publish_time", e.target.value)
                  }
                  disabled={mode === "VIEW"}
                />
              </article>

              <article className="col-span-12 sm:col-span-12 md:col-span-12 lg:col-span-12 space-y-2">
                <InputTextField
                  value={inputValue.name}
                  heading={t("ชื่อ")}
                  required
                  placeholder={t("ระบุชื่อ")}
                  onchange={(e: React.ChangeEvent<HTMLInputElement>) =>
                    handleChange("name", e.target.value)
                  }
                  disabled={mode === "VIEW"}
                />
              </article>

              <article className="col-span-12 sm:col-span-12 md:col-span-12 lg:col-span-12 space-y-2">
                <InputTextField
                  value={inputValue.detail}
                  heading={t("รายละเอียด")}
                  placeholder={t("ระบุรายละเอียด")}
                  onchange={(e: React.ChangeEvent<HTMLInputElement>) =>
                    handleChange("detail", e.target.value)
                  }
                  disabled={mode === "VIEW"}
                  row={3}
                  maxRows={5}
                  multiline
                  inputHeight={"auto"}
                />
              </article>

              {mode !== "VIEW" && (
                <article className="col-span-12 space-y-2">
                  <Typography variant="h6" gutterBottom>
                    {t("ไฟล์แนบ")}
                  </Typography>
                  <UploadFile
                    onDrop={handleDrop} // Main upload handler
                    file={null}
                    noClick={false} // Allow user to click and upload files
                  />
                </article>
              )}

              <article className="col-span-12 space-y-2">
                {files.length > 0 && (
                  <>
                    <Typography variant="h6" gutterBottom>
                      {t("ไฟล์แนบแล้ว")}
                    </Typography>
                    {files.map((file: any, index: number) => (
                      <UploadFile
                        key={file?.id}
                        fileAttachmentId={file?.id}
                        fileAttachmentName={file?.name}
                        file={!file?.is_api ? [file] : null}
                        onDrop={() => { }}
                        onDeleteFile={() => handleDeleteFile(index)}
                        {...(mode !== "VIEW" && {
                          onDeleteFileId: () => handleDeleteFile(index),
                        })}
                        noClick={true}
                        hiddenDownloadFile={false}
                        onDownloadFile={() =>
                          handleDownloadFile(file?.id, file?.type)
                        }
                      />
                    ))}
                  </>
                )}
              </article>

              <article className="col-span-12 space-y-2">
                <LinkCard
                  link={inputValue.link ?? ""}
                  onDelete={() => handleDeleteLink()}
                  onPaste={() => handlePasteLink()}
                  mode={mode}
                />
              </article>
            </section>

            <div className="mt-6 w-full flex justify-center gap-4 items-center">
              <span>
                <ButtonOutlined
                  onClick={handleCloseModal}
                  mode="del"
                  buttonName={t("ยกเลิก")}
                />
              </span>
              {mode !== "VIEW" && (
                <span>
                  <ButtonPrimary
                    mode="done"
                    buttonName={t("ยืนยัน")}
                    disabled={
                      !inputValue.publish_date ||
                      !inputValue.publish_time ||
                      !inputValue.name ||
                      files.length === 0
                    }
                    onClick={handleSubmit}
                  />
                </span>
              )}
            </div>
          </div>
        }
      />

      <NavigateListCustom
        navigateData={[
          {
            name: t("รายวิชาที่สอน ปีการศึกษา {{year}} ภาคเรียนที่ {{term}}", {
              year: prop_year,
              term: prop_term,
            }),
            key: "1",
            pathName: routeName.advisor.SubjectTaught,
            onClick: () =>
              navigate(
                `${routeName.advisor.SubjectTaught}/${prop_id_course_of_study}/course-annual?year=${prop_year}&term=${prop_term}`
              ),
          },
          {
            name: t("รหัสวิชา : {{courses_no}} / ชื่อรายวิชา : {{courses_name}}", {
              courses_no: prop_courses_no,
              courses_name: prop_courses_name,
            }),
            key: "2",
            pathName: "",
            onClick: () =>
              navigate(
                `${routeName.advisor.SubjectTaught}/${id}/course-annual-detail?courses_name=${prop_courses_name}&courses_no=${prop_courses_no}&id_course_of_study=${prop_id_course_of_study}&year=${prop_year}&term=${prop_term}`
              ),
          },
        ]}
      />

      {/* header */}
      <section className="my-4">
        <Typography variant="h3">{t("รหัสวิชา : {{courses_no}} / ชื่อรายวิชา : {{courses_name}}", {
          courses_no: prop_courses_no,
          courses_name: prop_courses_name,
        })}</Typography>
      </section>

      <div className="w-full grid grid-cols-12 gap-4 mt-[40px]">
        <article className="w-full col-span-12 lg:col-span-3 md:col-span-3 sm:col-span-3">
          <InputTextField
            startAdornment={<SearchOutlined />}
            placeholder={t("ค้นหาชื่อ")}
            onchange={(e: React.ChangeEvent<HTMLInputElement>) =>
              debouncedApiCall({
                searchItem: e.target.value,
                setItem: setSearch,
              })
            }
          />
        </article>

        <article className="w-full col-span-12 lg:col-span-9 md:col-span-9 sm:col-span-9 flex justify-end">
          <ButtonPrimary
            onClick={() => {
              setMode("ADD");
              setisModalForm(true);
            }}
            mode="add"
            buttonName={t("เพิ่มสื่อประกอบการเรียนการสอน")}
          />
        </article>
      </div>

      <section className="w-full mt-10">
        <TableCustom
          tableMinWidth={1440}
          tableFixedWidth
          customScroll
          page={page}
          pageLimit={pageLimit}
          sortBy={sortBy}
          sortType={sortType}
          headCells={headCells}
          rowCount={totalItems}
          rowsData={
            data &&
            data.map((data: any, i: any) => {
              return renderData(data, i);
            })
          }
          onSort={handleRequestSort}
          setPageLimit={(value: number) => setPageLimit(value)}
          setPage={(value: number) => setPage(value)}
        />
      </section>

      <section className="col-span-12 flex items-center justify-center gap-4 my-4">
        <ButtonOutlined
          onClick={() => {
            navigate(-1);
          }}
          buttonName={t("ย้อนกลับ")}
          btnProps={{
            width: "150px",
          }}
        />

        <ButtonPrimary
          onClick={() => {
            // handleSubmit(inputValueFormStudent.information);
            setOpen(true)
          }}
          mode="success"
          buttonName={t("ปิดคราสเรียน")}
          btnProps={{
            width: "150px",
          }}
        />
      </section>
      <ModalCustom maxWidth={800} title={t('ปิดคราสเรียน')} subTitle='' open={open} component={
        <div className='flex flex-col gap-4'>
          <div>
            <InputDatePicker heading={t("วันที่เริ่มต้นเปิดให้ประเมิน")} value={form?.estimate_start_date} onChange={function (val: any): void {
              setForm({ ...form, estimate_start_date: moment(val).format('YYYY-MM-DD') })
            }} />
          </div>
          <div>
            <InputDatePicker heading={t("วันที่สิ้นสุดเปิดให้ประเมิน")} value={form?.estimate_end_date} onChange={function (val: any): void {
              setForm({ ...form, estimate_end_date: moment(val).format('YYYY-MM-DD') })
            }} />
          </div>
          <div className='flex justify-center gap-4'>
            <ButtonBack
              onClick={() => {
                setOpen(false)
                setForm({})
              }}
              buttonName={t('ยกเลิก')}
            />
            <ButtonPrimary
              onClick={() => {
                handleClose();
              }}
              disabled={!form?.estimate_start_date || !form?.estimate_end_date}
              mode="success"
              buttonName={t("ยืนยัน")}
              btnProps={{
                width: "150px",
              }}
            />

          </div>
        </div>
      } />
    </div>
  );
};

export default SubjectTaughtCourseDetail;
